import { createFileRoute } from "@tanstack/react-router";
import CarDetail from "@/pages/CarDetailV3";
import { loadListingWithRedirect, listingHead } from "@/lib/seo/listing-seo";

export const Route = createFileRoute("/de/listing/$slug/")({
  loader: ({ params }) => loadListingWithRedirect(params.slug, "de"),
  head: ({ loaderData, params }) => listingHead(loaderData ?? null, params.slug, "de"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <CarDetail />
  );
}
